var productImagesGallery,initMasonry,initCountdown,simpleDropdown;
(function( $ ) {
  "use strict";

  // Init slick carousel
  var initCarousel = function() {
    if ("undefined" != typeof $.fn.slick && "undefined" != typeof $.fn.imagesLoaded) {
      $( '.jas-carousel' ).not( '.slick-initialized' ).slick();
    }
  }
  var metaslider_tea = function() {
    if ("undefined" != typeof $.fn.flexslider && "undefined" != typeof $.fn.imagesLoaded) {
      $('.metaslider_tea').addClass('flexslider'); // theme/plugin conflict avoidance
      $('.metaslider_tea').imagesLoaded(function() {
        $(".metaslider_tea").each(function (index) {
          var nav = $(this).data('nav'),
              dots = $(this).data('dots'),
              autoplay = $(this).data('autoplay'),
              loop = $(this).data('loop'),
              animation = $(this).data('animation'),
              speed = $(this).data('speed');
          var options = {
            rtl: $('body').hasClass('rtl'),
            slideshowSpeed:speed,
            animation:animation,
            controlNav:dots,
            directionNav:nav,
            pauseOnHover:true,
            direction:"horizontal",
            reverse:false,
            animationSpeed:1200,
            prevText:"←",
            nextText:"→",
            animationLoop: loop, 
            slideshow:autoplay
          };
          $(this).flexslider(options);
        });
      });
    }
  }
  var BannerMasonry = function() {
    if ("undefined" != typeof $.fn.isotope && "undefined" != typeof $.fn.imagesLoaded) {
      var b = $(".categories-masonry"),
          c = b.hasClass("categories-style-masonry") ? ".category-grid-item" : ".col-md-3.category-grid-item";
      b.imagesLoaded(function() {
        b.isotope({
          resizable: !1,
          isOriginLeft: !$("body").hasClass("rtl"),
          layoutMode: "packery",
          packery: {
            gutter: 0,
            // columnWidth: c
          },
          itemSelector: ".category-grid-item"
        })
      })
    }
  }
  /* ---------------------------------------------
     Resize mega menu
     --------------------------------------------- */
  var resizeMegamenu = function(){
    var window_size = jQuery('body').innerWidth();
    window_size += get_scrollbar_width();
    if( window_size > 767 ){
      if( $('#jas-header .jas-navigation').length >0){
        var container = $('#jas-header .jas-navigation');
        if( container!= 'undefined'){
          var container_width = 0;
          container_width = container.innerWidth();
          var container_offset = container.offset();
          setTimeout(function(){
            $('.jas-navigation .menu-item-has-children').each(function(index,element){
              $(element).children('.sub-menu').css({'max-width':container_width+'px'});
              var sub_menu_width = $(element).children('.sub-menu').outerWidth();
              var item_width = $(element).outerWidth();
              $(element).children('.sub-menu').css({'left':'-'+(sub_menu_width/2 - item_width/2)+'px'});
              var container_left = container_offset.left;
              var container_right = (container_left + container_width);
              var item_left = $(element).offset().left;
              var overflow_left = (sub_menu_width/2 > (item_left - container_left));
              var overflow_right = ((sub_menu_width/2 + item_left) > container_right);
              if( overflow_left ){
                var left = (item_left - container_left);
                $(element).children('.sub-menu').css({'left':-left+'px'});
              }
              if( overflow_right && !overflow_left ){
                var left = (item_left - container_left);
                left = left - ( container_width - sub_menu_width );
                $(element).children('.sub-menu').css({'left':-left+'px'});
              }
            })
          },100);
        }
      }
    }
  }
  var get_scrollbar_width = function()  {
    var $inner = jQuery('<div style="width: 100%; height:200px;">claue test</div>'),
        $outer = jQuery('<div style="width:200px;height:150px; position: absolute; top: 0; left: 0; visibility: hidden; overflow:hidden;"></div>').append($inner),
        inner = $inner[0],
        outer = $outer[0];
    jQuery('body').append(outer);
    var width1 = inner.offsetWidth;
    $outer.css('overflow', 'scroll');
    var width2 = outer.clientWidth;
    $outer.remove();
    return (width1 - width2);
  }
  var shopMasonry = function() {
    if ("undefined" != typeof $.fn.isotope && "undefined" != typeof $.fn.imagesLoaded) {
      var b = $(".elements-grid.grid-masonry");
      b.imagesLoaded(function() {
        b.isotope({
          isOriginLeft: !$("body").hasClass("rtl"),
          itemSelector: ".category-grid-item, .product-grid-item"
        })
      }), $(window).resize(function() {
        var b = $(".grid-masonry"),
            c = b.hasClass("categories-style-masonry") ? ".product-grid-item" : ".jas-col-xs-6.product-grid-item";
        b.imagesLoaded(function() {
          b.isotope({
            resizable: !1,
            isOriginLeft: !$("body").hasClass("rtl"),
            layoutMode: "packery",
            packery: {
              gutter: 0,
              columnWidth: c
            },
            itemSelector: ".category-grid-item"
          })
        })
      })
    }
  }

  simpleDropdown = function() {
    $('.input-dropdown-inner').each(function() {
      var dd = $(this);
      var btn = dd.find('> a');
      var input = dd.find('> input');
      var list = dd.find('> ul'); //.dd-list-wrapper

      $(document).click(function(e) {
        var target = e.target;
        if (dd.hasClass('dd-shown') && !$(target).is('.input-dropdown-inner') && !$(target).parents().is('.input-dropdown-inner')) {
          hideList();
          return false;
        }
      });

      btn.on('click', function(e) {
        e.preventDefault();
        if (dd.hasClass('dd-shown')) {
          hideList();
        } else {
          $('.input-dropdown-inner.dd-shown > ul').slideUp(100);
          $('.input-dropdown-inner.dd-shown').removeClass('dd-shown');
          showList();
        }
        return false;
      });

      list.on('click', 'a', function(e) {
        e.preventDefault();
        var value = $(this).data('val');
        var label = $(this).text();
        list.find('.current-item').removeClass('current-item');
        $(this).parent().addClass('current-item');
        if (value != 0) {
          list.find('li:first-child').show();
        } else if (value == 0) {
          list.find('li:first-child').hide();
        }
        var form = $(this).closest('form.has-categories-dropdown');
        form.attr('action','/search/collections/'+value);
        btn.text(label);
        input.val(value);
        hideList();
      });

      function showList() {
        dd.addClass('dd-shown');
        list.slideDown(100);
      }

      function hideList() {
        dd.removeClass('dd-shown');
        list.slideUp(100);
      }
    });
  }

  // Init masonry layout
  initMasonry = function() {
    var el = $( '.jas-masonry' );
    el.each( function( i, val ) {
      var _option = $( this ).data( 'masonry' );

      if ( _option !== undefined ) {
        var _selector = _option.selector,
            _width    = _option.columnWidth,
            _layout   = _option.layoutMode;

        $( this ).imagesLoaded( function() {
          $( val ).isotope( {
            layoutMode : _layout,
            itemSelector: _selector,
            percentPosition: true,
            masonry: {
              columnWidth: _width
            }
          } );
        });

        $( '.jas-filter a' ).click( function() {
          var selector = $( this ).data( 'filter' ),
              parent   = $( this ).parents( '.jas-filter' );

          $( val ).isotope({ filter: selector });

          // don't proceed if already selected
          if ( $( this ).hasClass( 'selected' ) ) {
            return false;
          }
          parent.find( '.selected' ).removeClass( 'selected' );
          $( this ).addClass( 'selected' );

          return false;
        });
      }
    });
  }

  // Initialize search form in header.
  //   productImagesGallery = function() {
  //     var $mainImages = $('.shopify-product-gallery__image:eq(0) img'),
  //         $thumbs = $('.p-nav'), // magnific photo-swipe
  //         $mainOwl;
  //     initThumbnailsMarkup();
  //     //$mainOwl = $('.p-nav').slick();
  //      $('.t_thum').not( '.slick-initialized' ).slick();
  //     //$('.p-nav_slick').slick( 'unslick' );
  //  // $('.p-nav_slick').not( '.slick-initialized' ).slick();
  //     function initThumbnailsMarkup() {
  //       var markup = '';

  //       $('.shopify-product-gallery__image').each(function() {
  //         if( $(this).data('variant_id') != undefined && $(this).data('lenght') != undefined ) {
  //           markup += '<div><img data-variant_id="' + $(this).data('variant_id') + '" data-lenght="' + $(this).data('lenght') + '" data-one="' + $(this).data('one') + '" data-two="' + $(this).data('two') + '" data-three="' + $(this).data('three') + '" src="' + $(this).data('thumb') + '" alt="' + $(this).data('alt') + '" data-image-id="' + $(this).data('id') + '"  /></div>';
  //         } else {
  //           markup += '<div><img src="' + $(this).data('thumb') + '" alt="' + $(this).data('alt') + '" data-image-id="' + $(this).data('id') + '"  /></div>';
  //         }
  //       });

  //       $thumbs.append(markup);

  //     };
  //   }
  // Initialize search form in header.
  var initSearchForm = function() {
    var HS = $( '.header__search' );

    // Open search form
    $( '.sf-open' ).on( 'click', function( e ) {
      if( theme.search_dropdown ) return;
      e.preventDefault();
      console.log('1');
      HS.fadeIn();
      HS.find( 'input[type="search"]' ).focus();
    });
    $( '#sf-close' ).on( 'click', function(ev) {
      ev.preventDefault();
      HS.fadeOut();
    });
  }

  var  searchFullScreen = function() {
    if( ! theme.search_dropdown ) return;
    console.log('2');
    var body = $('body'),
        searchWrapper = $('.claue-search-wrapper');

    body.on('click', '.sf-open >i', function(e) {
      e.preventDefault();
      if( isOpened() ) {
        closeWidget();
      } else {
        setTimeout( function() {
          openWidget();
        }, 10);
      }
    })


    body.on("click", ".claue-close-search, #jas-header, #jas-content", function(event) {

      if ( ! $(event.target).is('.claue-close-search') && $(event.target).closest(".claue-search-wrapper").length ) return;

      if( isOpened() ) {
        closeWidget();
      }
    });

    var closeWidget = function() {
      $('body').removeClass('claue-search-opened');
      searchWrapper.removeClass('search-overlap');
    };

    var openWidget = function() {

       $('body').addClass('claue-search-opened');
        searchWrapper.addClass('search-overlap');
        setTimeout(function() {
            searchWrapper.find('input[type="text"]').focus();
            $(window).one('scroll', function() {
                if( isOpened() ) {
                    closeWidget();
                }
            });
        }, 300);
    };

    var isOpened = function() {
      return $('body').hasClass('claue-search-opened');
    };
  }
  // Init push on header
  var initPushMenu = function() {
    $( 'a.jas-push-menu-btn' ).on( 'click', function (e) {
      e.preventDefault();
      var mask = '<div class="mask-overlay">';

      $( 'body' ).toggleClass( 'menu-opened' );
      $(mask).hide().appendTo( 'body' ).fadeIn( 'fast' );
      $( '.mask-overlay, .close-menu' ).on( 'click', function() {
        $( 'body' ).removeClass( 'menu-opened' );
        $( '.mask-overlay' ).remove();
      });
    });
  }

  // Accordion mobile menu
  var initDropdownMenu = function() {
    $( '#jas-mobile-menu ul li.has-sub' ).append( '<span class="holder"></span>' );
    $( 'body' ).on('click','.holder',function() {
      var el = $( this ).closest( 'li' );
      if ( el.hasClass( 'open' ) ) {
        el.removeClass( 'open' );
        el.find( 'li' ).removeClass( 'open' );
        el.find( 'ul' ).slideUp();
      } else {
        el.addClass( 'open' );
        el.children( 'ul' ).slideDown();
        el.siblings( 'li' ).children( 'ul' ).slideUp();
        el.siblings( 'li' ).removeClass( 'open' );
        el.siblings( 'li' ).find( 'li' ).removeClass( 'open' );
        el.siblings( 'li' ).find( 'ul' ).slideUp();
      }
    });
  }

  // Sticky menu
  var initStickyMenu = function() {         
    if ( JAS_Data_Js != undefined && JAS_Data_Js[ 'header_sticky' ] ) {
      var header          = document.getElementById( 'jas-header' ),
          headerMid       = document.getElementsByClassName( 'header__mid' )[0],
          headerMidHeight = $( '.header__mid' ).outerHeight(),
          headerTopHeight = $( '.header__top' ).outerHeight(),
          headerBotHeight = $( '.header__bot' ).outerHeight(),
          headerHeight    = headerMidHeight + headerTopHeight + headerBotHeight,
          adminBar        = $( '#admin_bar_iframe' ).length ? $( '#admin_bar_iframe' ).height() : 0;

      if ( headerMid == undefined ) return;

      header.setAttribute( 'style', 'height:' + headerHeight + 'px' );

      $( window ).scroll( function() {
        if ( $( this ).scrollTop() > headerTopHeight ) {
          header.classList.add( 'header-sticky' );
          headerMid.setAttribute( 'style', 'position: fixed;top:' + adminBar + 'px' );
        } else {
          header.classList.remove( 'header-sticky' );
          headerMid.removeAttribute( 'style' );
        }
      });
    }
  }

  // Init right to left menu
  // var initRTLMenu = function() {
  //   var menu = $( '.sub-menu li' ), subMenu = menu.find( ' > .sub-menu');
  //   menu.on( 'mouseenter', function () {
  //     if ( subMenu.length ) {
  //       if ( subMenu.outerWidth() > ( $( window ).outerWidth() - subMenu.offset().left ) ) {
  //         subMenu.addClass( 'rtl-menu' );
  //       }
  //     }
  //   });
  // }

  // Keep navigation dropdowns in the screen
  var menuOffsets = function() {

    var $window = $(window),
        $header = $('.header__mid'),
        mainMenu = $('#jas-menu'),
        lis = $('ul.sub_lv_third').parent().parent().parent();
        lis.find('.sub_lv_two').addClass('megamenu_nt');

    mainMenu.on('hover', ' > li', function(e) {
      console.log('hover menu');
      setOffset( $(this) );
    });

    var setOffset = function( li ) {

      var dropdown = li.find(' > .sub-menu'),
          siteWrapper = $('#jas-wrapper');


      dropdown.attr('style', '');

      var dropdownWidth = dropdown.outerWidth(),
          dropdownOffset = dropdown.offset(),
          screenWidth = $window.width(),
          bodyRight = siteWrapper.outerWidth() + siteWrapper.offset().left,
          viewportWidth = ( $('body').hasClass('wrapper-wide') || $('body').hasClass('wrapper-boxed-small') ) ? bodyRight : screenWidth;

      if( ! dropdownWidth || ! dropdownOffset ) return;

      if( $('body').hasClass('rtl') && dropdownOffset.left <= 0 && li.hasClass( 'menu-item-has-children' ) && ! $header.hasClass('header-vertical') ) {
        // If right point is not in the viewport
        var toLeft = - dropdownOffset.left;
        dropdown.css({
          right: - toLeft - 10
        });

        var beforeSelector = '.' + li.attr('class').split(' ').join('.') + '> .sub-menu:before',
            arrowOffset = toLeft + li.width()/2;

      } else if( dropdownOffset.left + dropdownWidth >= viewportWidth && li.hasClass( 'menu-item-has-children' ) && ! $header.hasClass('header-vertical') ) {
        // If right point is not in the viewport
        var toRight = dropdownOffset.left + dropdownWidth - viewportWidth;
        dropdown.css({
          left: - toRight - 10
        });

        var beforeSelector = '.' + li.attr('class').split(' ').join('.') + '> .sub-menu:before',
            arrowOffset = toRight + li.width()/2;

      }

      // Vertical header fit
      if( $header.hasClass('header-vertical') ) {

        var bottom = dropdown.offset().top + dropdown.outerHeight(),
            viewportBottom = $window.scrollTop() + $window.outerHeight();

        if( bottom > viewportBottom ) {
          dropdown.css({
            top: viewportBottom - bottom - 10
          });
        }
      }
    };

    lis.each(function() {
      setOffset( $(this) );
      $(this).addClass('with-offsets');
    });

  }

  // Init right to left menu
  var claue_instagram = function() {
    $(".claue_home_instagram").each(function (index) {
      var ul_ins = $(this),
          user_name = ul_ins.data('username'),
          limit = ul_ins.data('limit'),
          target = ul_ins.data('target'),
          img_size = ul_ins.data('size'),
          ul_ins_slider = ul_ins.find(".ins-owl-carousel"),
          ul_ins_html = ul_ins.find(".instagram-pics");
      $.ajax({
        url: 'https://api.teathemes.net/instagram?username='+user_name,
        dataType: 'json',
        type: 'GET',
        success: function(responsive) {
          var html = '',
              img_url = null,
              data = responsive.entry_data.ProfilePage[0].user.media.nodes;
          $.each(data,function(index,element){
            if(index >= limit ) return 0;
            if (img_size === 's150x150' ) {
              img_url = element.thumbnail_resources[0].src;
            }else if (img_size === 's240x240'){
              img_url = element.thumbnail_resources[1].src;
            }else if (img_size === 's320x320'){
              img_url = element.thumbnail_resources[2].src;
            }
            else if (img_size === 's480x480'){
              img_url = element.thumbnail_resources[3].src;
            }else {
               img_url = element.thumbnail_resources[4].src;
            }
            html += '<div class="item pr fl"><a href="//instagram.com/p/'+element.code+'" target="'+target+'"><img src="'+img_url+'" alt="'+user_name+'"><div class="info pa tc flex ts__03 center-xs middle-xs"><span class="pr cw mgr10"><i class="fa fa-heart-o mr__5"></i>'+element.likes.count+'</span><span class="pr cw"><i class="fa fa-comments-o mr__5"></i>'+element.comments.count+'</span></div></a></div>';
          });
          ul_ins_html.html(html);
        },
        error: function(data) {
          console.log('ajax error');
        },
        complete: function() {
          if ( typeof ul_ins_slider !== 'undefined' ) {
            ul_ins_slider.not( '.slick-initialized' ).slick();
          }
        }
      }); 
    });
  }

  // Initialize WC quantity adjust.
  var wcQuantityAdjust = function() {
    $( 'body' ).on( 'click', '.quantity .plus', function( e ) {
      e.preventDefault();
      var $input = $( this ).parent().parent().find( 'input' ),
          value = parseInt( $input.val() ) + 1,
          value_max = $input.attr('max');
      if ( value > value_max ) value = value_max;
      $input.val( value );

      // $input.trigger( 'change' );
    });
    $( 'body' ).on( 'click', '.quantity .minus', function( e ) {
      e.preventDefault();
      var $input = $( this ).parent().parent().find( 'input' );
      var value = parseInt( $input.val() ) - 1;
      if ( value < 1 ) value = $input.attr('min');
      $input.val( value );

      // $input.trigger( 'change' );
    });
  }
  var nathaQuantityAdjust = function() {
    $( 'body' ).on( 'click', '.quantity .cart__popup-qty--plus', function( e ) {
      e.preventDefault();
      $(".widget_shopping_cart_content").addClass('removing-process');
      $( '#content_cart__popup_nt' ).addClass('loading');
      var $input = $( this ).parent().parent().find( 'input' ),
          value = parseInt( $input.val() ) + 1,
          id =  $input.data("id"),
          value_max = $input.attr('max');
      if ( value > value_max ) value = value_max;
      $input.val( value );
      Shopify.pop_changeItem(id,value);
    });
    $( 'body' ).on( 'click', '.quantity .cart__popup-qty--minus', function( e ) {
      e.preventDefault();
      $(".widget_shopping_cart_content").addClass('removing-process');
      $( '#content_cart__popup_nt' ).addClass('loading');
      var $input = $( this ).parent().parent().find( 'input' );
      var value = parseInt( $input.val() ) - 1;
      var id =  $input.data("id");
      if ( value < 0 ) value = 0;
      $input.val( value );
      $( '#update_cart_popup' ).trigger( 'click' );
      if ( value > 0 ) {
        Shopify.pop_changeItem(id,value);
      }else {
        Shopify.pop_removeItem(id,value);
      }
    });
    $( 'body' ).on( 'keyup', '.cart__popup-qty--input', function( e ) {
      e.preventDefault();
      $(".widget_shopping_cart_content").addClass('removing-process');
      $( '#content_cart__popup_nt' ).addClass('loading');
      var id =  $( this ).data("id");
      var value =  $( this ).val();
      if ( value > 0 ) {
        Shopify.pop_changeItem(id,value);
      }else {
        Shopify.pop_removeItem(id,value);
      }
    });
  }
  var updateCartFromForm = function() {
    $( 'body' ).on( 'click', '#update_cart_popup', function( e ) {
      $(".widget_shopping_cart_content").addClass('removing-process');
      $( '#content_cart__popup_nt' ).addClass('loading');
      e.preventDefault();
      var params = {
        type: 'POST',
        url: '/cart/update.js',
        data: jQuery('#cart__popup_form').serialize(),
        dataType: 'json',
        success: function(cart) { 
          if ((typeof callback) === 'function') {
            callback(cart);
          }
          else {
            var item_count,customPrice;
            jQuery.getJSON('/cart.js', function(cart) {
              item_count = cart.item_count;
              customPrice = Shopify.formatMoney(cart.total_price, theme.moneyFormat);
              $(".cartCount").html(cart.item_count);
            });
            jQuery.get('/cart?view=json', function(data) {
              $('.widget_shopping_cart_content').html(data);
              $('.currency .active').trigger('click');
            });
            jQuery.get('/cart?view=up_ajax', function(data) {
              if(item_count == 0) {
                $('.cart__popup_content').html('').html(data);
              } else {
                $('#push_cart_items').html(data);
                $('#cart__popup_total').html(customPrice);
                $('.currency .active').trigger('click');
              }
            });
          }
        },
        complete: function() {
          setTimeout(function(){
            $(".widget_shopping_cart_content").removeClass('removing-process');
            $( '#content_cart__popup_nt' ).removeClass('loading');
          }, 300);
        },
        error: function(XMLHttpRequest, textStatus) {
          setTimeout(function(){
            $(".widget_shopping_cart_content").removeClass('removing-process');
            $( '#content_cart__popup_nt' ).removeClass('loading');
          }, 400);
          Shopify.onError(XMLHttpRequest, textStatus);
        }
      };
      jQuery.ajax(params);
    });
  }
  // Back to top button
  var backToTop = function() {
    var el = $( '#jas-backtop' );
    $( window ).scroll(function() {
      if( $( this ).scrollTop() > $( window ).height() ) {
        el.show();
      } else {
        el.hide();
      }
    });
    el.click( function() {
      $( 'body,html' ).animate({
        scrollTop: 0
      }, 500);
      return false;
    });
  }

  // Product quick view
  var initQuickView = function() {
    $( 'body' ).on( 'click', '.quick-view', function(e) {
      $.ajax({
        beforeSend : function (){
          $( '#jas-wrapper' ).after( '<div class="loader"><div class="loader-inner"></div></div>' );
        },
        url: $(this).attr('data-get'),
        success: function(data) {
          // alert(response)
          $.magnificPopup.open({
            items: {
              src: '<div class="mfp-with-anim popup-quick-view" id="content_quickview">' + data + '</div>', // can be a HTML string, jQuery object, or CSS selector
              type: 'inline'
            },
            removalDelay: 500, //delay removal by X to allow out-animation
            callbacks: {
              beforeOpen: function() {
                this.st.mainClass = 'mfp-move-horizontal';
              },
              open: function() {
                $('.product-images-slider_on').addClass('owl-carousel').slick({
                  rtl: $('body').hasClass('rtl'),
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  fade: true,
                  infinite: false
                });
                initCountdown();
                simpleDropdown();
                setTimeout(function() {
                  jQuery(".claue-scroll").nanoScroller({
                    paneClass: "claue-scroll-pane",
                    sliderClass: "claue-scroll-slider",
                    contentClass: "claue-scroll-content",
                    preventPageScrolling: !1
                  });
                }, 300);
                jQuery('.currency .active').trigger('click');
                if ($(".shopify-product-reviews-badge").length > 0 && theme.gl_productreviews ) {
                  return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
                }
              },
              close: function() {
                $( '#content_quickview' ).empty();
              }
            },
          });
        },
        complete: function() {
          $( '.loader' ).remove();
        }
      })
      return false; //for good measure
      e.preventDefault();
      e.stopPropagation();
    });
  }

  // Login before using wishlist
  var initloginwishlist = function() {
    $("body").on('click', '.nitro-wishlist-login', function(event) {
      event.preventDefault();
      /* Act on the event */
      var html = [
        '<div class="added-to-cart">',
        '<p>' + theme.wishlist.info_wishlist + '</p>',
        '<a href="#" class="btn btn-style-link close-popup">' + theme.wishlist.continue_shopping + '</a>',
        '<a href="/account/login" class="btn btn-color-primary view-cart button tu">' + theme.wishlist.login + '</a>',
        '</div>',
      ].join("");
        // Append new quantity selector then remove original
        $.magnificPopup.open({
        removalDelay: 400, //delay removal by X to allow out-animation
        callbacks: {
        beforeOpen: function() {
        this.st.mainClass = 'claue-popup-effect';
        },
        },
        items: {
        src: '<div id="login-wishlist" class="white-popup claue-promo-popup add-to-cart-popup popup-added_to_cart">' + html + '</div>',
        type: 'inline'
        }
        });

        $('.white-popup').on('click', '.close-popup', function(e) {
        e.preventDefault();
        $.magnificPopup.close();
        });
        }); 
        }
        // Add wishlist
        var addwishlist = function() {
        $("body").on('click', '.add_nitro_wishlist', function(event) {
        event.preventDefault();
        var $this = $(this),
        holder = $this.parent().siblings('.yith-wcwl-add-button'),
        load = $this.parent().find('.load_nitro_wishlist'),
        added = $this.parent().find('.added_nitro_wishlist');
        $this.hide();
        load.show();
        $.ajax({
        url: 'https://nitro-wishlist.teathemes.net?shop='+ Shopify.shop,
        type: 'POST',
        data: $this.data(),
        success: function(data,status) {
        try{
        data = $.parseJSON(data);
        }
        catch(ex){
        //console.log(ex);
        }
        if(data.status == 'success' && status == 'success')
        {
        added.show();
        load.hide();
        $this.hide();
        $('.gl_count_wishlist').html(function(i, val) { return val*1+1 });
        }else {
        load.hide();
        $this.show();
        console.log('ajax error');
        }
        },
        error: function(data) {
        load.hide();
        $this.show();
        console.log('ajax error');
        },
        });
        }); 
        }
        // Remove wishlist
        var removewishlist = function() {
        $("body").on('click', '.nitro_wishlist_remove', function(event) {
        event.preventDefault();
        var $this = $(this),
        value = $(this).data('id');
        $( '#jas-wrapper' ).after( '<div class="loader"><div class="loader-inner"></div></div>' );
        $.ajax({
        url: 'https://nitro-wishlist.teathemes.net?shop='+ Shopify.shop,
        type: 'POST',
        data: $this.data(),
        success: function(data,status) {
        try{
        data = $.parseJSON(data);
        }
        catch(ex){
        //console.log(ex);
        }
        if(data.status == 'success' && status == 'success') {
        $('.gl_count_wishlist').html(function(i, val) { return val*1-1 });
        $("#yith-wcwl-row-" + value).remove();
        $( '.loader' ).remove();
        var rowCount = $('.wishlist_table > tbody > tr').length;
        if (rowCount < 1) {
        $('.wishlist_table tbody').empty();
        $('.wishlist_table tbody').append('<tr><td colspan="6" class="wishlist-empty">'+ theme.productStrings.nowishlist +'</td>');
        } 
        } else {
        $( '.loader' ).remove();
        console.log('ajax error');
        }
        },
        error: function(data) {
        $( '.loader' ).remove();
        console.log('ajax error');
        },
        });
        }); 
        }

        // Init Magnific Popup
        var initMagnificPopup = function() {
        if ( $( '.jas-magnific-image' ).length > 0 ) {
        $( '.jas-magnific-image' ).magnificPopup({
        type: 'image',
        tLoading: '<div class="loader"><div class="loader-inner"></div></div>',
        removalDelay: 500,
        callbacks: {
        beforeOpen: function() {
        this.st.image.markup = this.st.image.markup.replace('mfp-figure', 'mfp-figure mfp-with-anim tea_size_chart');
        this.st.mainClass = this.st.el.attr('data-effect');
        }
        }
        });
        }
        }

        // Extra content on single product ( Help & Shipping - Return )
        var wcExtraContent = function() {
        if ( $( '.jas-wc-help' ).length > 0 ) {
        $( '.jas-wc-help' ).magnificPopup({
        type: 'inline',
        tLoading: '<div class="loader"><div class="loader-inner"></div></div>',
        removalDelay: 500,
        callbacks: {
        beforeOpen: function() {
        this.st.mainClass = 'claue-popup-effect';
        }
        }
        });
        }
        }

        // Init mini cart on header
        var initMiniCart = function() {
        $( 'body' ).on( 'click', '.jas_nt_side > a', function (e) {
        e.preventDefault();
        var mask = '<div class="mask-overlay">';

        $( 'body' ).toggleClass( 'cart-opened' );
        $( mask ).hide().appendTo( 'body' ).fadeIn( 'fast' );
        $( '.mask-overlay, .close-cart' ).on( 'click', function() {
        $( 'body' ).removeClass( 'cart-opened' );
        $( '.mask-overlay' ).remove();
        });
        });
        }

        // Open video in popup
        var wcInitPopupVideo = function() {
        if ( $( '.p-video' ).length > 0 ) {
        $( '.jas-popup-url' ).magnificPopup({
        disableOn: 0,
        tLoading: '<div class="loader"><div class="loader-inner"></div></div>',
        type: 'iframe'
        });

        $( '.jas-popup-mp4' ).magnificPopup({
        disableOn: 0,
        type: 'inline'
        });
        }
        }
        $( '.jas-wc-help' ).magnificPopup({
        type: 'inline',
        tLoading: '<div class="loader"><div class="loader-inner"></div></div>',
        removalDelay: 500,
        callbacks: {
        beforeOpen: function() {
        this.st.mainClass = 'claue-popup-effect';
        }
        }
        });

        // quickShop settings
        var quickShop = function() {
        var btnSelector = '.btn-quick-shop';

        $(document).on('click', btnSelector, function( e ) {
        e.preventDefault();

        var $this = $(this),
        $product = $this.parents('.t_col'),
        $content = $product.find('.quick-shop-form'),
        id = $this.data('id'),
        loadingClass = 'btn-loading';

        if( $this.hasClass(loadingClass) ) return;


        // Simply show quick shop form if it is already loaded with AJAX previously
        if( $product.hasClass('quick-shop-loaded') ) {
        $product.addClass('quick-shop-shown');
        return;
        }

        $this.addClass(loadingClass);
        $product.addClass('loading-image');

        $.ajax({
        url: $(this).attr('data-get'),
        method: 'get',
        success: function(data) {

        // insert variations form
        $content.append(data);

        },
        complete: function() {
        simpleDropdown();
        jQuery('.currency .active').trigger('click');
        $this.removeClass(loadingClass);
        $product.removeClass('loading-image');
        $product.addClass('quick-shop-shown quick-shop-loaded');
        },
        error: function() {
        },
        });

        })

        .on('click', '.quick-shop-close', function() {
        var $this = $(this),
        $product = $this.parents('.t_col'),
        $content = $product.find('.quick-shop-form');

        $product.removeClass('quick-shop-shown quick-shop-loaded');
        $content.html('');

        });

        }

        // swatchesOnGrid settings
        var swatchesOnGrid = function() {

        $('body').on('click', '.swatch-on-grid', function() {

        var src, srcset, image_sizes;

        var imageSrc = $(this).data('image-src'),
        imageSrcset = $(this).data('image-srcset'),
        imageSizes = $(this).data('image-sizes');

        if( typeof imageSrc == 'undefined' ) return;

        var product = $(this).parents('.product-grid-item'),
        image = product.find('img').first(),
        srcOrig = image.data('original-src'),
        srcsetOrig = image.data('original-srcset'),
        sizesOrig = image.data('original-sizes');

        if( typeof srcOrig == 'undefined' ) {
        image.data('original-src', image.attr('src'));
        }

        if( typeof srcsetOrig == 'undefined' ) {
        image.data('original-srcset', image.attr('srcset'));
        }

        if( typeof sizesOrig == 'undefined' ) {
        image.data('original-sizes', image.attr('sizes'));
        }


        if( $(this).hasClass('current-swatch') ) {
        src = srcOrig;
        srcset = srcsetOrig;
        image_sizes = sizesOrig;
        $(this).removeClass('current-swatch');
        product.removeClass('product-swatched');
        } else {
        $(this).parent().find('.current-swatch').removeClass('current-swatch');
        $(this).addClass('current-swatch');
        product.addClass('product-swatched');
        src = imageSrc;
        srcset = imageSrcset;
        image_sizes = imageSizes;
        }

        if( image.attr('src') == src ) return;

        product.addClass('loading-image');

        image.attr('src', src).attr('srcset', srcset).attr('sizes', image_sizes).one('load', function() {
        product.removeClass('loading-image');
        });

        });

        }

        // Init Scroll Reveal
        var initScrollReveal = function() {
        window.sr = ScrollReveal().reveal( '.jas-animated', {
        duration: 700
        });
        }

        // Init elevate zoom
        var wcInitImageZoom = function() {
        if ( $( '.jas-image-zoom' ).length > 0 ) {
        var img = $( '.jas-image-zoom' ), img_src = $( '.jas-image-zoom' ).data( 'src' );
        img.zoom({
        touch: false,
        url: img_src
        });
        }
        }

        // Init Countdown
        //         function initCountdown() {
        //         var el = $( '.jas-countdown' );

        //         el.each( function( i, val ) {
        //         var _option = $( this ).data( 'time' );

        //         if ( _option !== undefined ) {
        //         var _day   = _option.day,
        //         _month = _option.month,
        //         _year  = _option.year,
        //         _end   = _month + ' ' + _day + ', ' + _year + ' 00:00:00';

        //         $( val ).countdown( {
        //         date: _end,
        //         render: function(data) {
        //         $( this.el ).html("<div class='pr'><span class='db cw fs__16 mt__10'>" + this.leadingZeros(data.days, 2) + "</span><span class='db'>days</span></div><div class='pr'><span class='db cw fs__16 mt__10'>" + this.leadingZeros(data.hours, 2) + "</span><span class='db'>hrs</span></div><div class='pr'><span class='db cw fs__16 mt__10'>" + this.leadingZeros(data.min, 2) + "</span><span class='db'>mins</span></div><div class='pr'><span class='db cw fs__16 mt__10'>" + this.leadingZeros(data.sec, 2) + "</span><span class='db'>secs</span></div>");
        //         }
        //         });
        //         }
        //         });
        //         }

        initCountdown = function() {
        $('.jas-countdown').each(function() {
        $(this).countdown($(this).data('time'), function(event) {
        $(this).html(event.strftime(''
        + '<div class="pr"><span class="db cw fs__16 mt__10">%-D</span><span class="db">days</span></div>'
        + '<div class="pr"><span class="db cw fs__16 mt__10">%H</span><span class="db">hrs</span></div>'
        + '<div class="pr"><span class="db cw fs__16 mt__10">%M</span><span class="db">mins</span></div>'
        + '<div class="pr"><span class="db cw fs__16 mt__10">%S</span><span class="db">secs</span></div>'));
        });
        });
        }

        // Init product accordion
        function wcAccordion() {

        $( '.wc-accordions .tab-heading' ).click( function( e ) {
        e.preventDefault();

        var _this = $( this );
        var parent = _this.closest( '.wc-accordion' );
        var parent_top = _this.closest( '.wc-accordions' );

        if ( parent.hasClass( 'active' ) ) {
        parent.removeClass( 'active' );
        parent.find( '.entry-content' ).stop( true, true ).slideUp();
        } else {
        parent_top.find( '.wc-accordion' ).removeClass( 'active' );
        parent.addClass( 'active' );
        parent_top.find( '.entry-content' ).stop( true, true ).slideUp();
        parent.find( '.entry-content' ).stop( true, true ).slideDown();
        }
        } );
        }

        // Sticky sidebar for single product layout 3
        function wcStickySidebar() {
        if ( $( '.jas-sidebar-sticky' ).length > 0 ) {
        $( '.jas-sidebar-sticky' ).stick_in_parent();
        }
        }

        function initVideoBackgrounds() {
        // return window.console && window.console.warn && window.console.warn("this function is deprecated use galaxy_initVideoBackgrounds"),
        galaxy_initVideoBackgrounds()
        }
        function fullHeightRow() {
        var $element = $(".gl_row-o-full-height:first");
        if ($element.length) {
        var $window, windowHeight, offsetTop, fullHeight;
        $window = $(window), windowHeight = $window.height(), offsetTop = $element.offset().top, offsetTop < windowHeight && (fullHeight = 100 - offsetTop / (windowHeight / 100), $element.css("min-height", fullHeight + "vh"))
        }
        $(document).trigger("gl-full-height-row", $element)
        }
        function galaxy_initVideoBackgrounds() {
        jQuery("[data-gl-video-bg]").each(function() {
        var youtubeUrl, youtubeId, $element = jQuery(this);
        $element.data("glVideoBg") ? (youtubeUrl = $element.data("glVideoBg"),
        youtubeId = galaxyExtractYoutubeId(youtubeUrl),
        youtubeId && ($element.find(".gl_video-bg").remove(),
        insertYoutubeVideoAsBackground($element, youtubeId)),
        jQuery(window).on("grid:items:added", function(event, $grid) {
        $element.has($grid).length && galaxyResizeVideoBackground($element)
        })) : $element.find(".gl_video-bg").remove()
        })
        }
        function insertYoutubeVideoAsBackground($element, youtubeId, counter) {
        if ("undefined" == typeof YT || "undefined" == typeof YT.Player)
        return counter = "undefined" == typeof counter ? 0 : counter,
        100 < counter ? void console.warn("Too many attempts to load YouTube api") : void setTimeout(function() {
        insertYoutubeVideoAsBackground($element, youtubeId, counter++)
        }, 100);
        var $container = $element.prepend('<div class="gl_video-bg gl_hidden-xs"><div class="inner"></div></div>').find(".inner");
        new YT.Player($container[0],{
          width: "100%",
          height: "100%",
          videoId: youtubeId,
          playerVars: {
          playlist: youtubeId,
          iv_load_policy: 3,
          enablejsapi: 1,
          disablekb: 1,
          autoplay: 1,
          controls: 0,
          showinfo: 0,
          rel: 0,
          loop: 1,
          wmode: "transparent"
        },
          events: {
            onReady: function(event) {
              event.target.mute().setLoop(!0)
            }
          }
    }),
      galaxyResizeVideoBackground($element),
      jQuery(window).bind("resize", function() {
      galaxyResizeVideoBackground($element)
    })
  }
  function galaxyResizeVideoBackground($element) {
    var iframeW, iframeH, marginLeft, marginTop, containerW = $element.innerWidth(), containerH = $element.innerHeight(), ratio1 = 16, ratio2 = 9;
    containerW / containerH < ratio1 / ratio2 ? (iframeW = containerH * (ratio1 / ratio2),
                                                 iframeH = containerH,
                                                 marginLeft = -Math.round((iframeW - containerW) / 2) + "px",
                                                 marginTop = -Math.round((iframeH - containerH) / 2) + "px",
                                                 iframeW += "px",
                                                 iframeH += "px") : (iframeW = containerW,
                                                                     iframeH = containerW * (ratio2 / ratio1),
                                                                     marginTop = -Math.round((iframeH - containerH) / 2) + "px",
                                                                     marginLeft = -Math.round((iframeW - containerW) / 2) + "px",
                                                                     iframeW += "px",
                                                                     iframeH += "px"),
      $element.find(".gl_video-bg iframe").css({
      maxWidth: "1000%",
      marginLeft: marginLeft,
      marginTop: marginTop,
      width: iframeW,
      height: iframeH
    });
  }
  function galaxyExtractYoutubeId(url) {
    if ("undefined" == typeof url)
      return !1;
    var id = url.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
    return null !== id && id[1]
  }
  // Preloader
  //   function initPreLoader() {
  //     var loader = $( '.preloader' );

  //     if ( loader.length ) {
  //       $( window ).on( 'beforeunload', function() {
  //         loader.fadeIn( 500, function() {
  //           loader.children().fadeIn( 100 )
  //         });
  //       });

  //       loader.fadeOut( 800 );
  //       loader.children().fadeOut();
  //     }
  //   }
  function productsLoadMore() {
    var process = false, intervalID;
    $(document).off('click', '.claue-products-load-more').on('click', '.claue-products-load-more', function(e) {
      e.preventDefault();
      if (process) return;
      process = true;
      var $this = $(this);
      if (theme.has_collection) {
        var holder = $this.parent().siblings('.yit-wcan-container').children('.claue-products-holder');
        console.log('1')
      } else {
        var holder = $this.parent().siblings('.claue-products-holder');
        console.log('2')
      }
      var  tea_ajaxurl = $(this).attr('href');
      loadProducts(holder, tea_ajaxurl, $this, function(data) {
        data = jQuery(data);
        var html = data.find('#tea_data_products').html(),
            data_status = data.find('#tea_data_arrow').attr("data-status"),
            data_load_more = data.find('#tea_section_next').attr("href");
        if( holder.hasClass('jas-masonry') ) {
          isotopeAppend(holder, html);
        } else {
          holder.append(html);
        }
        if( data_status == 'have-posts' ) {
          $this.attr("href", data_load_more);
          $this.text(theme.productStrings.MoreText);
        } else {
          //$this.hide().remove();
          $this.text(theme.productStrings.noMoreText).addClass('disabled');
        }
      });
    });

    var loadProducts = function(holder, ajaxurl, btn, callback) {

      holder.addClass('loading').parent().addClass('element-loading');
      //btn.addClass('loading');
      btn.html( '<i class="fa fa-circle-o-notch fa-spin"></i>' )

      $.ajax({
        dataType: "html",
        type: 'GET',
        url: ajaxurl,
        success: function(data) {
          callback( data );
        },
        error: function(data) {
          console.log('ajax error');
        },
        complete: function() {
          //currency
          jQuery('.currency .active').trigger('click');
          holder.removeClass('loading').parent().removeClass('element-loading');
          //btn.removeClass('loading');
          //btn.text(theme.productStrings.MoreText);
          initCountdown();
          //product review
          if ($(".shopify-product-reviews-badge").length > 0 && theme.gl_productreviews ) {
            $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
          }
          process = false;
        },
      });
    };

    var isotopeAppend = function(el, items) {
      // initialize Masonry after all images have loaded
      var items = $(items);
      //console.log(items);
      el.append(items).isotope( 'appended', items );
      el.isotope('layout');
      setTimeout(function() {
        el.isotope('layout');
      }, 100);
      el.imagesLoaded().progress(function() {
        el.isotope('layout');
      });
    };

  }

  /**
   * DOMready event.
   */
  $( document ).ready( function() {
    FastClick.attach(document.body);
    initVideoBackgrounds();
    fullHeightRow();
    productsLoadMore();
    metaslider_tea();
    initCarousel();
    initMasonry();
    BannerMasonry();
    resizeMegamenu();
    shopMasonry();
    simpleDropdown();
    quickShop();
    swatchesOnGrid();
    initSearchForm();
    searchFullScreen();
    //productImagesGallery();
    initDropdownMenu();
    initPushMenu();
    //initRTLMenu();
    menuOffsets();
    claue_instagram();
    initQuickView();
    initloginwishlist();
    addwishlist();
    removewishlist();
    //initPreLoader();
    initMiniCart();
    initScrollReveal();
    initCountdown();
    backToTop();
    initMagnificPopup();
    wcInitPopupVideo();
    wcQuantityAdjust();
    nathaQuantityAdjust();
    wcExtraContent();
    wcAccordion();
    wcStickySidebar();
    wcInitImageZoom();
    $(document).on('click', ".add_to_cart_button", function(event) {
      $(this).attr('disabled', 'disabled').css('pointer-events', 'none').addClass('loading');
      var $this = $(this);
      event.preventDefault();
      setTimeout(function(){
        $this.removeAttr("disabled").css('pointer-events', 'none').removeClass("add_to_cart_button loading").addClass('added-cart').text( theme.productStrings.view_cart ).attr( { href:"/cart", onclick:"" } );
        $this.parent().addClass('fix_nt');
      }, 500);
    });
    $(document).on('click', ".add_to_cart_quick", function(event) {
      $(this).attr('disabled', 'disabled').css('pointer-events', 'none').addClass('loading');
      var $this = $(this);
      event.preventDefault();
      setTimeout(function(){
        $this.removeAttr("disabled").css('pointer-events', 'auto').removeClass("loading");
      }, 500);
    });
    // Save note anytime it's changed
    $(document.body).on('change', '#CartSpecialInstructions', function() {
      var newNote = $(this).val();
      // Update the cart note in case they don't click update/checkout
      Shopify.glupdateCartNote(newNote);
    });

    // Collection sidebar recent view
    var ls = Currency.cookie.tearead('tea-recent');
    if(ls != null){ 
      ls = ls.split(',');
      var lr = ls.reverse();
      var length = ls.length;
      // show many products
      ls = ls.slice(0,2);
      $("#recently-viewed-products").show();
      $.each(lr,function(index, el) {      
        if(el != ""){
          jQuery.getJSON('/products/' + el + '.js', function (product, textStatus) {
            $('.tea_recently_wrap').append(LoopProduct(product));
          });
        }
      });
    }else{
      ls = new Array();
    }
    function LoopProduct(product){
      var on_sale = false ;
      if (product.compare_at_price > product.price )
        on_sale = true ;
      var html ='';

      html += '<li>';
      html +='<a href="/products/'+product.handle+'" title=" '+product.title+' ">';
      html+='<img width="80" height="102" src="'+Shopify.resizeImage(product.featured_image,'80x102')+'" class="primary_image" alt="'+product.title+'">';
      html +='<span class="product-title"> '+product.title+' </span>';
      html +='</a>';
      if( product.price_varies ){
        html +='<span class="money">'+Shopify.convertWithCurrency(product.price_min)+'</span>-<span class="money">'+Shopify.convertWithCurrency(product.price_max)+'</span>';
      }else if(on_sale){
        html +='<del><span class="money">'+Shopify.convertWithCurrency(product.compare_at_price)+'</span></del> <ins><span class="money">'+Shopify.convertWithCurrency(product.price)+'</span></ins>';
      }else{
        html +='<span class="money">'+Shopify.convertWithCurrency(product.price)+'</span>';
      }
      html +='</li>';

      return html;
    }
  });
  $( window ).load( function() {
    //initCarousel();
    initStickyMenu();
    // wcInitImageZoom();
     $('body').addClass('cl_loaded');
  });

  $( window ).resize(function() {
    BannerMasonry();
  });

  window.TeaLookBook = window.TeaLookBook || {};

  jQuery(window).load(function(){
    TeaLookBook.CartCallback = function(data){
      // console.log(data);
      jQuery.get('/cart?view=json', function(data) {
        /*optional stuff to do after success */
        $('.widget_shopping_cart_content').html(data);
        $('.currency .active').trigger('click');
      });
      jQuery.getJSON('/cart.js', function(cart) {
        $(".cartCount").html(cart.item_count);
      });
      console.log('asdsa');
      Shopify.cartPopap();
    }
  });
})( jQuery );
